import { render } from "./organizationList.vue?vue&type=template&id=0ba1e3cc&scoped=true"
import script from "./organizationList.vue?vue&type=script&lang=js"
export * from "./organizationList.vue?vue&type=script&lang=js"

import "./organizationList.vue?vue&type=style&index=0&id=0ba1e3cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba1e3cc"]])

export default __exports__